// extracted by mini-css-extract-plugin
export default {"loading":"cYO8gxq1GrhLyjtX8M4g"};